import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Configuration } from '@shared/models/configuration';
import { CommandService } from '@core/services/command.service';
import { FileManagementService } from '@core/services/file-management.service';
import { SmartGridService } from '@core/services/smart-grid.service';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { DownloadFileCommand } from '../../../commands/create-directory.command';
import { DownloadFileAction } from '../../../store/actions/file-manager.actions';
import { FileManagerState } from '../../../store/reducers/file-manager.reducer';

@Component({
    standalone: false,
    selector: 'particle-version-history-dialog-view',
  templateUrl: './version-history-dialog-view.component.html',
  styleUrls: ['./version-history-dialog-view.component.scss']
})
export class VersionHistoryDialogViewComponent implements OnInit, IDialogView {

  data: DialogModel;

  constructor(private smartGridService: SmartGridService,
              private commandService: CommandService,
              private fileManagementService: FileManagementService,
              private store: Store<FileManagerState>) { }

  ngOnInit() {
    const newConfig = Configuration.getSmartGridConfig(this.data.input.sourceKey);
    newConfig.Parameters['FILE_ID'] = this.data.input.fileId;
    Configuration.setSmartGridConfig(this.data.input.sourceKey, newConfig);
    this.smartGridService.initDataProvider(this.data.input.sourceKey);
  }

  onOkClicked() {
    return true;
  }
  onGridCellValueChange($event) {
    console.log('Downolad event', $event);
    if ($event.action) {
      switch ($event.action.id) {
        case 'Download':
          const downloadFileCommand = new DownloadFileCommand($event.item.cells.FileEntryId.value,
            $event.item.cells.FileContentId.value, true, null, 5, 10, true);
          this.commandService.executeCommand(downloadFileCommand).pipe().subscribe(data => {
            console.log('Download File', data);
            this.fileManagementService.downloadOneTimeSignedUrl(data.Payload['DownloadUrl'], data.Payload['FileName']);
          });
          break;
      }
    }
  }
}
